import React from 'react';
import { Check, Loader2, Clock } from 'lucide-react';

export type StepStatus = 'pending' | 'in_progress' | 'completed' | 'error';

export interface ProgressStep {
  label: string;
  status: StepStatus;
}

interface StepProgressIndicatorProps {
  steps: ProgressStep[];
  className?: string;
}

export function StepProgressIndicator({ steps, className = '' }: StepProgressIndicatorProps) {
  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-6 ${className}`}>
      <div className="space-y-3">
        {steps.map((step, index) => (
          <div key={index} className="flex items-center gap-3">
            <div className="flex-shrink-0">
              {step.status === 'completed' && (
                <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center">
                  <Check className="w-4 h-4 text-white" />
                </div>
              )}
              {step.status === 'in_progress' && (
                <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center">
                  <Loader2 className="w-4 h-4 text-white animate-spin" />
                </div>
              )}
              {step.status === 'pending' && (
                <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
                  <Clock className="w-4 h-4 text-gray-400" />
                </div>
              )}
              {step.status === 'error' && (
                <div className="w-6 h-6 rounded-full bg-red-500 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">!</span>
                </div>
              )}
            </div>
            <p
              className={`text-sm ${
                step.status === 'completed'
                  ? 'text-gray-500'
                  : step.status === 'in_progress'
                  ? 'text-[#231F20] font-medium'
                  : step.status === 'error'
                  ? 'text-red-600 font-medium'
                  : 'text-gray-400'
              }`}
            >
              {step.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
